import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Card,
  Row,
  Col,
  Badge,
  Alert,
  Spinner,
  Button,
  ListGroup,
} from "react-bootstrap";
import {
  FaStore,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaFileAlt,
  FaUser,
} from "react-icons/fa";

const VendorProfile = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [profile, setProfile] = useState(null);
  // Use dynamic base URL approach like other admin components
const API_BASE =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:3000";

  useEffect(() => {
    fetchProfile();
  }, [id]);

  const fetchProfile = async () => {
    try {
      setLoading(true);
      const adminToken =
        localStorage.getItem("adminToken") ||
        sessionStorage.getItem("adminToken");
      const headers = {
        "Content-Type": "application/json",
      };
      if (adminToken) {
        headers["Authorization"] = `Bearer ${adminToken}`;
      }

      const res = await fetch(`${API_BASE}/api/vendors/${id}`, { headers });

if (!res.ok) {
  throw new Error(`Failed to load vendor profile: ${res.status}`);
}

const data = await res.json();
      const vendor = data.vendor;
      if (!vendor) throw new Error("No vendor returned");

      // Normalize document URLs (support multiple backend field names)
      // First check for verification documents in personal_info
      const personalInfoDocs =
        (vendor.vendor &&
          vendor.vendor.personal_info &&
          vendor.vendor.personal_info.documents) ||
        {};
      // Then check for general documents
      const generalDocs =
        (vendor.vendor && vendor.vendor.documents) || vendor.documents || {};

      const normDocs = {
        pan_card_url:
          personalInfoDocs.pan_card_url ||
          generalDocs.pan_card_url ||
          generalDocs.panCardUrl ||
          generalDocs.panCard ||
          "",
        aadhaar_url:
          personalInfoDocs.aadhaar_url ||
          generalDocs.aadhaar_url ||
          generalDocs.aadhaarUrl ||
          generalDocs.aadhaar ||
          "",
        bank_proof_url:
          personalInfoDocs.bank_proof_url ||
          generalDocs.bank_proof_url ||
          generalDocs.bankProofUrl ||
          generalDocs.bankProof ||
          "",
        certificates_url:
          personalInfoDocs.certificates_url ||
          generalDocs.certificates_url ||
          "",
        // Add verification-specific Aadhaar documents (these take precedence)
        aadhaar_front_url: personalInfoDocs.aadhaar_front_url || "",
        aadhaar_back_url: personalInfoDocs.aadhaar_back_url || "",
      };

      const normalizedVendor = {
        ...vendor,
        vendor: {
          ...(vendor.vendor || {}),
          documents: normDocs,
        },
      };

      setProfile(normalizedVendor);
      setLoading(false);
    } catch (e) {
      console.error(e);
      setError(e.message || "Failed to load vendor profile");
      setLoading(false);
    }
  };

  // Live presence polling – refresh online status/lastActive every 15s
  useEffect(() => {
    let timer;
    const fetchPresence = async () => {
      try {
        const adminToken =
          localStorage.getItem("adminToken") ||
          sessionStorage.getItem("adminToken");
        const headers = {
          "Content-Type": "application/json",
        };
        if (adminToken) {
          headers["Authorization"] = `Bearer ${adminToken}`;
        }

        const res = await fetch(`${API_BASE}/api/vendors/${id}`, { headers });

if (!res.ok) {
  throw new Error(`Failed to load vendor profile: ${res.status}`);
}

const data = await res.json();

        if (!data || !data.vendor) return;
        if (!data.vendor) return;
        const vendor = data.vendor;

        // Normalize documents like initial load
        // First check for verification documents in personal_info
        const personalInfoDocs =
          (vendor.vendor &&
            vendor.vendor.personal_info &&
            vendor.vendor.personal_info.documents) ||
          {};
        // Then check for general documents
        const generalDocs =
          (vendor.vendor && vendor.vendor.documents) || vendor.documents || {};

        const normDocsIncoming = {
          pan_card_url:
            personalInfoDocs.pan_card_url ||
            generalDocs.pan_card_url ||
            generalDocs.panCardUrl ||
            generalDocs.panCard ||
            "",
          aadhaar_url:
            personalInfoDocs.aadhaar_url ||
            generalDocs.aadhaar_url ||
            generalDocs.aadhaarUrl ||
            generalDocs.aadhaar ||
            "",
          bank_proof_url:
            personalInfoDocs.bank_proof_url ||
            generalDocs.bank_proof_url ||
            generalDocs.bankProofUrl ||
            generalDocs.bankProof ||
            "",
          certificates_url:
            personalInfoDocs.certificates_url ||
            generalDocs.certificates_url ||
            "",
          // Add verification-specific Aadhaar documents (these take precedence)
          aadhaar_front_url: personalInfoDocs.aadhaar_front_url || "",
          aadhaar_back_url: personalInfoDocs.aadhaar_back_url || "",
        };

        const normalizedVendor = {
          ...vendor,
          vendor: {
            ...(vendor.vendor || {}),
            documents: normDocsIncoming,
          },
        };

        setProfile((prev) => {
          const prevDocs = (prev && prev.vendor && prev.vendor.documents) || {};
          const mergedDocs = {
            pan_card_url:
              normDocsIncoming.pan_card_url || prevDocs.pan_card_url || "",
            aadhaar_url:
              normDocsIncoming.aadhaar_url || prevDocs.aadhaar_url || "",
            bank_proof_url:
              normDocsIncoming.bank_proof_url || prevDocs.bank_proof_url || "",
            certificates_url:
              normDocsIncoming.certificates_url ||
              prevDocs.certificates_url ||
              "",
            aadhaar_front_url:
              normDocsIncoming.aadhaar_front_url ||
              prevDocs.aadhaar_front_url ||
              "",
            aadhaar_back_url:
              normDocsIncoming.aadhaar_back_url ||
              prevDocs.aadhaar_back_url ||
              "",
          };
          return {
            ...(prev || {}),
            ...normalizedVendor,
            vendor: {
              ...(normalizedVendor.vendor || {}),
              documents: mergedDocs,
            },
          };
        });
      } catch (_) {
        // ignore presence errors
      }
    };
    timer = setInterval(fetchPresence, 15000);
    return () => {
      if (timer) clearInterval(timer);
    };
  }, [id]);

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "40vh" }}
      >
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  if (error) {
    return (
      <Alert variant="danger">
        <Alert.Heading>Error</Alert.Heading>
        <p>{error}</p>
        <Button variant="outline-danger" onClick={fetchProfile}>
          Retry
        </Button>
      </Alert>
    );
  }

  if (!profile) {
    return <div>No vendor profile found</div>;
  }

  console.log("API_BASE:", API_BASE);

const handleReupload = async (type, file) => {
  if (!file) return;

  try {
    const adminToken =
      localStorage.getItem("adminToken") ||
      sessionStorage.getItem("adminToken");

    const formData = new FormData();
    formData.append("file", file);
    formData.append("type", type);

    const res = await fetch(
      `${API_BASE}/api/admin/vendors/${id}/upload-document`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${adminToken}`,
        },
        body: formData,
      }
    );
    console.log(
  "UPLOAD URL:",
  `${API_BASE}/api/admin/vendors/${id}/upload-document`
);

    if (!res.ok) {
      throw new Error(`Upload failed: ${res.status}`);
    }

    await fetchProfile(); // refresh profile
  } catch (error) {
    console.error("Reupload failed:", error);
    alert("Failed to re-upload document");
  }
};

const handleDelete = async (type) => {
  if (!window.confirm("Are you sure you want to delete this document?")) return;

  try {
    const adminToken =
      localStorage.getItem("adminToken") ||
      sessionStorage.getItem("adminToken");

    const res = await fetch(
      `${API_BASE}/api/admin/vendors/${id}/delete-document`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${adminToken}`,
        },
        body: JSON.stringify({ type }),
      }
    );

    if (!res.ok) throw new Error("Delete failed");

    fetchProfile();
  } catch (error) {
    console.error("Delete failed:", error);
    alert("Failed to delete document");
  }
};

  const getLastActiveTs = (p) => {
    const candidates = [
      p.lastActive,
      p.vendor && p.vendor.lastActive,
      p.activity && p.activity.lastActive,
      p.status && p.status.lastActive,
      p.updatedAt,
      p.vendor && p.vendor.personal_info && p.vendor.personal_info.lastActive,
    ].filter(Boolean);
    return candidates.length > 0 ? candidates[0] : null;
  };

  const computeOnline = (p) => {
    try {
      if (p.isOnline) return true;
      const ts = getLastActiveTs(p);
      if (!ts) return false;
      const last = new Date(ts).getTime();
      const now = Date.now();
      return now - last < 5 * 60 * 1000;
    } catch {
      return false;
    }
  };

  const isOnline = computeOnline(profile);
  const lastTs = getLastActiveTs(profile);
  const lastActiveDisplay = lastTs ? new Date(lastTs).toLocaleString() : "—";

  const statusBadge = (status) => (
    <Badge
      bg={String(status).toLowerCase() === "active" ? "success" : "secondary"}
    >
      {String(status).toUpperCase()}
    </Badge>
  );

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h1 className="mb-1">
            <FaStore className="me-2 text-primary" />
            {profile.vendor.personal_info.name}
          </h1>
          <p className="text-muted mb-0">Vendor Profile • ID: {profile.id}</p>
          <div className="mt-1">
            {isOnline ? (
              <Badge bg="success">Active now</Badge>
            ) : (
              <span className="text-muted small">
                Last active: {lastActiveDisplay}
              </span>
            )}
          </div>
        </div>
        <div>
          <div className="d-flex gap-2">
            <Button variant="outline-secondary" onClick={() => navigate(-1)}>
              Back
            </Button>
          </div>
        </div>
      </div>

      <Row>
        <Col md={8}>
          <Card className="mb-4">
            <Card.Header>
              <h5 className="mb-0">Business & Contact</h5>
            </Card.Header>
            <Card.Body>
              <Row>
                <Col md={6}>
                  <p>
                    <strong>Name:</strong> {profile.vendor.personal_info.name}
                  </p>
                  <p>
                    <FaEnvelope className="me-2" />
                    {profile.vendor.personal_info.email}
                  </p>
                  <p>
                    <FaPhone className="me-2" />
                    {profile.vendor.personal_info.phone}
                  </p>
                  <p>
                    <FaMapMarkerAlt className="me-2" />
                    {profile.vendor.personal_info.address}
                  </p>
                  <p>
                    <strong>Category:</strong> {profile.businessCategory || "—"}
                  </p>
                  <p>
                    <strong>Status:</strong> {statusBadge(profile.status)}
                  </p>
                </Col>
                <Col md={6}>
                  <p>
                    <strong>About:</strong>{" "}
                    {profile.vendor.personal_info.about || "—"}
                  </p>
                  <p>
                    <strong>Availability:</strong>{" "}
                    {profile.vendor.availability.join(", ")}
                  </p>
                  <p>
                    <strong>Created:</strong>{" "}
                    {profile.createdAt
                      ? new Date(profile.createdAt).toLocaleString()
                      : "—"}
                  </p>
                  <p>
                    <strong>Updated:</strong>{" "}
                    {profile.updatedAt
                      ? new Date(profile.updatedAt).toLocaleString()
                      : "—"}
                  </p>
                  <p>
                    <strong>Last Active:</strong>{" "}
                    {isOnline ? "Active now" : lastActiveDisplay}
                  </p>
                </Col>
              </Row>
            </Card.Body>
          </Card>

          <Card className="mb-4">
            <Card.Header>
              <h5 className="mb-0">Categories & Services</h5>
            </Card.Header>
            <Card.Body>
              {profile.vendor.categories &&
                profile.vendor.categories.length > 0 ? (
                <div>
                  {profile.vendor.categories.map((cat, idx) => (
                    <div key={idx} className="mb-3">
                      <h6 className="mb-2">{cat.category_name}</h6>
                      {cat.services && cat.services.length > 0 ? (
                        <ListGroup>
                          {cat.services.map((svc, i) => (
                            <ListGroup.Item
                              key={i}
                              className="d-flex justify-content-between align-items-start"
                            >
                              <div>
                                <div className="fw-bold">
                                  {svc.service_name}
                                </div>
                                <div className="text-muted small">
                                  {svc.description}
                                </div>
                              </div>
                              <div className="ms-3 fw-bold">₹{svc.price}</div>
                            </ListGroup.Item>
                          ))}
                        </ListGroup>
                      ) : (
                        <div className="text-muted small">No services</div>
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-muted">No categories</div>
              )}
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="mb-4">
            <Card.Header>
              <h5 className="mb-0">Documents</h5>
            </Card.Header>
            <Card.Body>
              <div className="mb-3">
                <FaUser className="me-2" />
                <strong>Profile Picture:</strong>

                {profile.vendor.personal_info.profile_image_url ? (
                  <>
                    <a
                      href={profile.vendor.personal_info.profile_image_url}
                      target="_blank"
                      rel="noreferrer"
                      className="ms-2"
                    >
                      View Image
                    </a>
                  </>
                ) : (
                  <span className="ms-2 text-muted">Not Uploaded</span>
                )}

                <div className="mt-2 d-flex gap-2">
                  <input
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    id="profileReupload"
                    onChange={(e) =>
                      handleReupload("profile", e.target.files[0])
                    }
                  />

                  <Button
                    size="sm"
                    variant="outline-primary"
                    onClick={() =>
                      document.getElementById("profileReupload").click()
                    }
                  >
                    Re-upload
                  </Button>

                  {profile.vendor.personal_info.profile_image_url && (
                    <Button
                      size="sm"
                      variant="outline-danger"
                      onClick={() => handleDelete("profile")}
                    >
                      Delete
                    </Button>
                  )}
                </div>
              </div>

              <div className="mb-3">
                <FaFileAlt className="me-2" />
                <strong>Aadhaar Card:</strong>

                {profile.vendor.documents.aadhaar_front_url ? (
                  <>
                    <a
                      href={profile.vendor.documents.aadhaar_front_url}
                      target="_blank"
                      rel="noreferrer"
                      className="ms-2"
                    >
                      View Document
                    </a>
                  </>
                ) : (
                  <span className="ms-2 text-muted">Not Uploaded</span>
                )}

                <div className="mt-2 d-flex gap-2">
                  <input
                    type="file"
                    accept="image/*,.pdf"
                    style={{ display: "none" }}
                    id="aadhaarReupload"
                    onChange={(e) =>
                      handleReupload("aadhaar", e.target.files[0])
                    }
                  />

                  <Button
                    size="sm"
                    variant="outline-warning"
                    onClick={() =>
                      document.getElementById("aadhaarReupload").click()
                    }
                  > 
                    Re-upload
                  </Button>

                  {profile.vendor.documents.aadhaar_front_url && (
                    <Button
                      size="sm"
                      variant="outline-danger"
                      onClick={() => handleDelete("aadhaar")}
                    >
                      Delete
                    </Button>
                  )}
                </div>
              </div>

            </Card.Body>
          </Card>

          <Card className="mb-4">
            <Card.Header>
              <h5 className="mb-0">Business Certificate</h5>
            </Card.Header>
            <Card.Body>
              <p className="mb-0">
                <FaFileAlt className="me-2" />
                Certificate:
                {profile.vendor.documents.certificates_url ? (
                  <a
                    href={profile.vendor.documents.certificates_url}
                    target="_blank"
                    rel="noreferrer"
                    className="ms-2"
                  >
                    View Certificate
                  </a>
                ) : (
                  <span className="ms-2 text-muted">Not Uploaded</span>
                )}
              </p>
            </Card.Body>
          </Card>

          <Card>
            <Card.Header>
              <h5 className="mb-0">Referral</h5>
            </Card.Header>
            <Card.Body>
              <p className="mb-2">
                <strong>Code:</strong>{" "}
                {profile.vendor.referral_info.referral_code}
              </p>
              <p className="mb-2">
                <strong>Points:</strong>{" "}
                {profile.vendor.referral_info.referral_points}
              </p>
              <p className="mb-0">
                <strong>Total Referrals:</strong>{" "}
                {profile.vendor.referral_info.referrals_count}
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default VendorProfile;
